<template>
  <v-card class="white vetalfa-view" :max-width="_getMaxWidth()">
    <div v-if="!isDrugsManagement" class="vetalfa-header" ref="screenHeader">
      <vetalfa-small-header
        :isDrugsManagement="isDrugsManagement"
        :backMethod="managementBackMethod"
        :title="category ? category.portugueseName : null"
        hasShareOption
      ></vetalfa-small-header>
      <vetalfa-drugs-header
        v-if="product"
        :isDrugsMode="false"
        :name="product.name"
        :description="product.brand"
      ></vetalfa-drugs-header>
    </div>
    <div v-if="product" ref="screenContent">
      <vetalfa-carousel
        id="product-photos"
        v-if="product.photos && product.photos.length"
        :items="product.photos"
      ></vetalfa-carousel>
      <vetalfa-section-title
        v-if="drugs.length"
        :prop="
          [9, 10, 12, 13].includes(
            !!product.category ? product.category.id : false
          )
            ? _getLabel('FEATURES')
            : _getLabel('ACTIVE_PRINCIPLE')
        "
        isCollapsed
        collapse
      >
        <vetalfa-section-link
          v-for="drug in drugs"
          :key="drug.id"
          :prop="drug"
        ></vetalfa-section-link>
      </vetalfa-section-title>
      <vetalfa-section-title
        v-if="product.animals.length"
        :prop="_getLabel('ALLOWED_ANIMALS')"
      >
        <vetalfa-section-item-title
          :prop="_getLabel('ALLOWED_ANIMALS_APPLICATION')"
        >
          <v-row align="start" class="pa-0 ma-0 pr-2">
            <v-col :cols="animalsColumnNumber" class="pa-0 ma-0">
              <vetalfa-section-item
                v-for="animal in product.animals"
                :key="animals.getAnimalPlural(animal)"
                :prop="animals.getAnimalPlural(animal)"
              ></vetalfa-section-item>
            </v-col>
            <v-spacer></v-spacer>
            <v-col
              align="center"
              align-self="end"
              cols="2"
              class="ma-0 pa-0 mt-1"
            >
              <v-row class="ma-0 pa-0" align="end" justify="end">
                <div
                  cols="2"
                  class="ma-0 pa-0"
                  v-for="(animal, index) in product.animals"
                  :key="animals.getAnimalDescription(animal)"
                  v-bind:class="index == 1 ? 'ml-2' : ''"
                >
                  <v-img
                    max-width="30px"
                    :src="animals.getAnimalIcon(animal)"
                  ></v-img>
                  <p class="product-animal-name ma-0 pa-0">
                    {{ animals.getAnimalDescription(animal) }}
                  </p>
                </div>
              </v-row>
            </v-col>
          </v-row>
        </vetalfa-section-item-title>
        <vetalfa-section-item-title
          v-if="_isNotEmpty(this.product.petSizes)"
          :prop="_getLabel('FOOD_PET_SIZES')"
        >
          <vetalfa-section-item
            v-for="(item, index) in this.product.petSizes"
            :index="index"
            :key="`pet-sizes-${item}`"
            :prop="item"
          >
          </vetalfa-section-item>
        </vetalfa-section-item-title>
        <vetalfa-section-item-title
          v-if="_isNotEmpty(this.product.petAges)"
          :prop="_getLabel('FOOD_PET_AGES')"
        >
          <vetalfa-section-item
            v-for="(item, index) in this.product.petAges"
            :key="`pet-ages-${item}`"
            :index="index"
            :prop="item"
          >
          </vetalfa-section-item>
        </vetalfa-section-item-title>
        <vetalfa-section-item-title
          v-if="_isNotEmpty(this.product.petBreeds)"
          :prop="_getLabel('FOOD_PET_BREEDS')"
        >
          <vetalfa-section-item
            v-for="(item, index) in this.product.petBreeds"
            :key="`pet-breeds-${item}`"
            :index="index"
            :prop="item"
          >
          </vetalfa-section-item>
        </vetalfa-section-item-title>
      </vetalfa-section-title>
      <vetalfa-section-title
        v-if="isFoodCategory"
        :prop="_getLabel('FOOD_TYPE')"
      >
        <vetalfa-section-item
          :prop="this.product.category.portugueseName"
        ></vetalfa-section-item>
      </vetalfa-section-title>
      <vetalfa-section-title
        v-if="isFoodCategory && _isNotEmpty(this.product.classes)"
        :prop="_getLabel('FOOD_CLASSES')"
      >
        <vetalfa-section-item
          v-for="(item, index) in this.product.classes"
          :key="`pet-classes-${item}`"
          :prop="item"
          :index="index"
        >
        </vetalfa-section-item>
      </vetalfa-section-title>
      <vetalfa-section-title
        v-if="isFoodCategory && _isNotEmpty(this.product.features)"
        :prop="_getLabel('FEATURES')"
      >
        <vetalfa-section-item
          v-for="(item, index) in this.product.features"
          :key="`pet-features-${item}`"
          :index="index"
          :prop="item"
        >
        </vetalfa-section-item>
      </vetalfa-section-title>
      <vetalfa-section-title
        v-if="isFoodCategory"
        :prop="_getLabel('PRESENTATION')"
      >
        <vetalfa-section-item-title
          :prop="_getLabel('foodPresentation')(this.product.presentation)"
        >
          <vetalfa-section-item
            :index="index"
            v-for="(item, index) in this.product.volumes"
            :key="`pet-volumes-${item}`"
            :prop="item"
          >
          </vetalfa-section-item>
        </vetalfa-section-item-title>
      </vetalfa-section-title>
      <div v-for="section in product.sections" :key="section.description">
        <vetalfa-carousel
          v-if="section.photo"
          :items="[section.photo]"
          expandCarousel
        ></vetalfa-carousel>
        <vetalfa-section-title
          v-else
          :prop="section.description"
          :collapse="section.collapse"
          :isCollapsed="true"
        >
          <vetalfa-simple-table v-if="section.table" :table="section.table">
          </vetalfa-simple-table>
          <vetalfa-section-paragraph
            v-for="(paragraph, index) in section.paragraphs"
            :key="index + paragraph"
            :prop="paragraph"
          ></vetalfa-section-paragraph>
          <vetalfa-section-item-title
            v-for="obj1 in section.objects"
            :key="obj1.description"
            :prop="obj1.description"
          >
            <vetalfa-simple-table v-if="obj1.table" :table="obj1.table">
            </vetalfa-simple-table>
            <vetalfa-section-item
              v-for="(obj2, index) in obj1.objects"
              :key="index + obj2.description"
              :prop="obj2.description"
              :index="index"
            >
              <vetalfa-simple-table
                v-if="obj2.table"
                :table="obj2.table"
              ></vetalfa-simple-table>
              <vetalfa-section-sub-item
                v-for="(obj3, index) in obj2.objects"
                :key="index + obj3.description"
                :prop="obj3.description"
                :index="index"
              >
                <vetalfa-simple-table
                  v-if="obj3.table"
                  :table="obj3.table"
                ></vetalfa-simple-table>
              </vetalfa-section-sub-item>
            </vetalfa-section-item>
          </vetalfa-section-item-title>
        </vetalfa-section-title>
      </div>
      <vetalfa-section-title prop="* Atenção" collapse isCollapsed>
        <vetalfa-section-item-title
          prop="As informações contidas nessa seção foram extraídas manualmente da bula e/ou site do fabricante."
        >
          <vetalfa-section-item
            prop="O conteúdo aqui disposto não contempla todas as informações contidas na bula."
          ></vetalfa-section-item>
          <vetalfa-section-item
            prop="As informações extraídas foram dispostas de forma a facilitar a leitura e a inteligibilidade informacional."
          ></vetalfa-section-item>
          <vetalfa-section-item
            prop="Recomendamos a leitura da bula em sua plenitude sempre que for prescrever algum medicamento ou produto."
          ></vetalfa-section-item>
        </vetalfa-section-item-title>
      </vetalfa-section-title>
      <div style="height: 30px; background-color: white"></div>
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import animals from "@/constants/animals.enum.js";
export default {
  name: "Products",
  methods: {
    ...mapActions("drugs", ["openProduct", "getSummary"]),
    ...mapMutations("drugs", ["setProduct"]),
    managementBackMethod() {
      this.setProduct(null);
    },
    setupScreen() {
      if (!this.isDrugsManagement) {
        this.openProduct({
          category: this.$route.params.category,
          id: this.$route.params.id,
        }).then(() => {
          this._setupScreenSizes(this);
        });
      }
    },
  },
  computed: {
    ...mapGetters("drugs", ["product", "drugsSummary", "category"]),
    isFoodCategory() {
      return this.product.category && this.product.category.foods;
    },
    animalsColumnNumber: function () {
      if (this.product.animals) {
        switch (this.product.animals.length) {
          case 2:
            return 8;
          case 1:
            return 10;
        }
      }
      return 12;
    },
    productsCollection() {
      return this.product.category ? this.product.category.collection : "drugs";
    },
    drugs() {
      let arr = [];
      if (
        !!this.drugsSummary &&
        !!this.drugsSummary[this.productsCollection] &&
        !!this.product
      ) {
        this.product.drugs.forEach((d) => {
          let summary = this.drugsSummary[this.productsCollection].find(
            (el) => el.id === d.id
          );
          d["hasLink"] = !!summary;
          if (!summary || !summary.disabled) {
            arr.push(d);
          }
        });
      }
      return arr;
    },
  },
  data() {
    return {
      animals,
      headerHeight: 0,
    };
  },

  watch: {
    "$route.params.id": {
      handler: function () {
        this.setupScreen();
      },
      deep: true,
      immediate: false,
    },
  },

  mounted() {
    this.setupScreen();
  },
  props: {
    isDrugsManagement: {
      type: Boolean,
      default: false,
    },
  },
};
</script>